export const categoriesAndProperties = {
  properties: "Properties",
  addProperty: "Add Property",
  addCategory: "Add Category",
  addSubCategory: "Add Sub Category",
  addExtraCategory: "Add Extra Category",
  category: "Category",
  subCategory: "Sub-category",
  subCategories: "Sub-categories",
  extraCategory: "Extra-category",
  extraCategories: "Extra-categories",
  selectProperty: "Select Property",
  isNumerical: "Is Numerical",
  value: "Value",
  uom: "UOM",
  selectCategory: "Select Category",
  // ===============================================================
};
